import { AdtEventAction } from '~/services/api/enums';
import { IHospitalCounters } from '~/services/api/hospital/types';

export const getCards = (counters: IHospitalCounters, styles: any) => [
  {
    title: 'Registrations & Pre-Admissions',
    value: counters?.registrationsAndPreAdmissionsCount ?? 0,
    className: styles.registrationCount,
    eventIds: [AdtEventAction.PreAdmit, AdtEventAction.Register],
  },
  {
    title: 'Admissions',
    value: counters?.admissionsCount ?? 0,
    className: styles.admissionsCount,
    eventIds: [AdtEventAction.Admit],
  },
  {
    title: 'Transfers',
    value: counters?.transfersCount ?? 0,
    className: styles.transfersCount,
    eventIds: [AdtEventAction.Transfer],
  },
  {
    title: 'Discharges',
    value: counters?.dischargesCount ?? 0,
    className: styles.dischargesCount,
    eventIds: [AdtEventAction.Discharge],
  },
  {
    title: 'Cancellations',
    value: counters?.cancellationsCount ?? 0,
    className: styles.cancellationsCount,
    eventIds: [AdtEventAction.CancelAdmit],
  },
];

export default {};
